import { atom } from 'jotai';
import { unwrap } from 'jotai/utils';
import { EventDescriptionsMapAtom } from '@/types/event';
import { getAtomForSection } from '@/utils/atoms/section';
import { eventDataDescriptionsAtom, eventMarkersDescriptionsAtom } from './queries/eventData';
import { playerEventDataDescriptionsAtom, playerEventMarkersDescriptionsAtom } from './queries/player/playerEventData';
import { teamEventDataDescriptionsAtom, teamEventMarkersDescriptionsAtom } from './queries/team/teamEventData';

const eventMarkersDescriptionsSectionMapAtom = atom<EventDescriptionsMapAtom>(() => ({
  player: playerEventMarkersDescriptionsAtom,
  team: teamEventMarkersDescriptionsAtom,
  dataLocker: eventMarkersDescriptionsAtom,
}));

const markersDescriptionsAtom = atom(getAtomForSection(eventMarkersDescriptionsSectionMapAtom));

export const unwrappedMarkersDescriptionsAtom = unwrap(markersDescriptionsAtom, prev => prev || []);

const eventDataDescriptionsSectionMapAtom = atom<EventDescriptionsMapAtom>(() => ({
  player: playerEventDataDescriptionsAtom,
  team: teamEventDataDescriptionsAtom,
  dataLocker: eventDataDescriptionsAtom,
}));

export const sectionEventDataDescriptionsAtom = atom(getAtomForSection(eventDataDescriptionsSectionMapAtom));

export const unwrappedEventDataDescriptionsAtom = unwrap(sectionEventDataDescriptionsAtom, prev => prev || []);
